import toFixedValue from 'app/common/lib/toFixedValue'

import { Entity } from './types'

export const createDataItemSimple = ({
  title,
  count,
  sum,
  isOnlyTitle,
}: {
  title: string
  count?: number
  sum?: number
  isOnlyTitle?: boolean
}) => {
  return {
    [Entity.Title]: (title || '').trim(),
    [Entity.TotalCount]: count || count === 0 ? String(count) : '',
    [Entity.TotalSum]: toFixedValue(sum),
    [Entity.IsOnlyTitle]: !!isOnlyTitle,
  }
}
